import React from 'react';
import logo from '../assets/logo-vilarouca-horizontal.svg';

function Header() {
  return (
    <header className="site-header">
      <div className="site-header__mark">
        <img className="site-header__logo" src={logo} alt="Canal de Ética GV" />
        <p className="site-header__tagline" aria-hidden="true">
          <span>Ética hoje</span>
          <span>constrói</span>
          <span>amanhã</span>
        </p>
      </div>
    </header>
  );
}

export default Header;
